import { FileEntity, } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  publicLinkId: string;
  formId: number;
  pageFieldUuid: string;
  fileEntity: FileEntity;
  // File can be `null` if the user used "Insert Template" feature, or somehow duplicated the existing file
  file: File | null;
  // ------------------------------------------------------------------------------------------------------
}


interface ResponseDataType {
  created_file_dto: FileEntity;
}

export const createPublicLinkCustomFormReportFormFileFieldsRequest = ({
                                                                        publicLinkId,
                                                                        formId,
                                                                        pageFieldUuid,
                                                                        fileEntity,
                                                                        file,
                                                                      }: RequestParams): Promise<ResponseDataType> => {
  const formData = new FormData();

  formData.append('page_field_uuid', pageFieldUuid);
  formData.append('file_dto', JSON.stringify(fileEntity));
  if (file) {
    formData.append('upload_file', file);
  }

  return ApiServiceInstance.makeRequest(`/custom-form-report/public-link/${ publicLinkId }/${ formId }/file-fields`, {
    method: 'POST',
    body: formData,
  });
};